import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-behind-square-3, copy 3, layers, pages"} maskId="square-filled-radius-0-stroke-1-IconSquareBehindSquare3"><path fillRule="evenodd" clipRule="evenodd" d="M16 8V2H2V16H8V22H22V8H16ZM9 16H16V9H21V21H9V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareBehindSquare3;
